/**
 * Utility helpers for the widget SDK
 */

/**
 * Generate a short random hex ID
 * @param {number} [bytes=6]
 * @returns {string}
 */
export function generateId(bytes = 6) {
    const arr = new Uint8Array(bytes);
    crypto.getRandomValues(arr);
    return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Format a Date to HH:MM:SS AM/PM
 * @param {Date} date
 * @returns {string}
 */
export function formatTime(date) {
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}

/**
 * Create a DOM element with attributes
 * @param {string} tag
 * @param {Object} [attrs]
 * @param {string|Element|Element[]} [children]
 * @returns {HTMLElement}
 */
export function el(tag, attrs = {}, children = null) {
    const node = document.createElement(tag);
    for (const [key, val] of Object.entries(attrs)) {
        if (key === 'className') node.className = val;
        else if (key === 'style' && typeof val === 'object') Object.assign(node.style, val);
        else if (key.startsWith('on')) node.addEventListener(key.slice(2).toLowerCase(), val);
        else node.setAttribute(key, val);
    }
    if (children) {
        if (typeof children === 'string') node.textContent = children;
        else if (Array.isArray(children)) children.forEach((c) => c && node.appendChild(c));
        else node.appendChild(children);
    }
    return node;
}
